import React from 'react';
import { Button } from '@heycater/design-system';
import PropTypes from 'prop-types';

function ScrollToTopButton({ children, ...restProps }) {
  return (
    <Button
      onClick={() => window.scroll({ top: 0, behavior: 'smooth' })}
      size="lg"
      rounded
      {...restProps}
    >
      {children}
    </Button>
  );
}

ScrollToTopButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ScrollToTopButton;
